import React, { PureComponent } from 'react';

import { ThunkDispatch } from 'redux-thunk';
import { Actions } from '../store/actions';
import { GlobalState } from '../store/reducers';
import FeedPage from './communication/FeedPage';
import PostPage from './communication/PostPage';
import ErrorPage from './ErrorPage';
import VitalsDetailsPage from './vitals/VitalsDetailsPage';
import VitalsHome from './vitals/VitalsHome';
import VisitVideoCall from './VisitVideoCall';
import EndVideoCall from './EndVideoCall';
import AddAddress from './address/AddAddress';
import ConsentFormPage from './consentForm/ConsentFormPage';
import LogMeInAndrForward from './LogMeInAndrForward';
import Abha from './Abha';
import AbhaLinkComplete from './AbhaLinkComplete';

export const APP_PREFIX = '/app';
export const OUT_PAGES = `${APP_PREFIX}/out`;
export const DIRECT_PAGES = `/app/direct`;
export const GO_TO_ERROR_PAGE = `${APP_PREFIX}/error`;

export const GO_TO_FEED = (docId: string, postId: string): string =>
    `${APP_PREFIX}/feed/${docId}/${postId}`;
export const GO_TO_POST_WITH_ID = (postId: string): string => `${APP_PREFIX}/post/${postId}`;

export const GO_TO_VITALS_HOME = `${APP_PREFIX}/vitals/`;
export const GO_TO_VITALS_DETAILS = (vid: string): string => `${APP_PREFIX}/vitals/${vid}`;

export const GO_TO_START_CALL_WITH_ID = (vId: string): string =>
    `${APP_PREFIX}/visit/start-call/${vId}`;
export const GO_TO_END_CALL_WITH_ID = (vId: string): string =>
    `${APP_PREFIX}/visit/end-call/${vId}`;

export const GO_TO_ADD_ADDRESS = (patient_oid: string, magiclink_hash?: string): string =>
    `${APP_PREFIX}/add-address/${patient_oid}/${magiclink_hash}`;

export const CONSENT_FORM = (id: string): string => `${APP_PREFIX}/consent-form/${id}`;

export const LOG_ME_IN_AND_FORWARD = (auth: string): string => `${DIRECT_PAGES}/login/${auth}`;
export const ABHA_LINK = (hash: string): string => `${APP_PREFIX}/abha/${hash}`;
export const ABHA_LINK_COMPLETE = (
    abhaid: string,
    forwardUrl: string = '',
    visitid: string = '',
    magicLink: string = '',
): string =>
    `${APP_PREFIX}/abha-complete/${abhaid}${forwardUrl ? `?forwardUrl=${forwardUrl}` : ''}${
        visitid ? `${forwardUrl ? '&' : '?'}visitid=${visitid}` : ''
    }${magicLink ? `${visitid || forwardUrl ? '&' : '?'}magicLink=${magicLink}` : ''}`;

export interface AppRoute {
    path: string;
    component: typeof PureComponent;
    setUpStore?: (
        store: { dispatch: ThunkDispatch<GlobalState, null, Actions> },
        params: any,
    ) => Promise<void>;
    exact?: boolean;
    isOutApp?: boolean;
    title?: string;
    pageTrackingName?: string;
}

export type VitalDetailsRouteProps = {
    vid?: string;
};

export type FeedPageRouterProps = {
    docId?: string;
    postId?: string;
};

export type ConsentFormPageRouterProps = {
    id?: string;
};

export type PostPageRouterProps = {
    postId: string;
};

export type RouteParams = VitalDetailsRouteProps | FeedPageRouterProps | PostPageRouterProps;

const routes: AppRoute[] = [
    {
        path: GO_TO_END_CALL_WITH_ID(':vId'),
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        component: EndVideoCall,
        exact: true,
        pageTrackingName: 'End_Video_Call',
    },
    {
        path: GO_TO_START_CALL_WITH_ID(':vId'),
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        component: VisitVideoCall,
        exact: true,
        pageTrackingName: 'Start_Video_Call',
    },
    {
        path: GO_TO_ERROR_PAGE,
        exact: true,
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        component: ErrorPage,
        pageTrackingName: 'Error_page',
    },
    {
        path: GO_TO_VITALS_HOME,
        exact: true,
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        component: VitalsHome,
        pageTrackingName: 'Vitals_home_page',
    },
    {
        path: GO_TO_VITALS_DETAILS(':vid'),
        exact: true,
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        component: VitalsDetailsPage,
        pageTrackingName: 'Vitals_details_page',
    },
    {
        path: GO_TO_FEED(':docId?', ':postId?'),
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        component: FeedPage,
        pageTrackingName: 'Feed_page',
    },
    {
        path: GO_TO_POST_WITH_ID(':postId'),
        exact: true,
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        component: PostPage,
        pageTrackingName: 'Post_page',
    },
    {
        path: GO_TO_ADD_ADDRESS(':patient_oid', ':magiclink_hash?'),
        exact: true,
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        component: AddAddress,
        pageTrackingName: 'Add_Address',
    },
    {
        path: CONSENT_FORM(':id'),
        exact: true,
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        component: ConsentFormPage,
        pageTrackingName: 'ConsentFormPage',
    },
    {
        path: LOG_ME_IN_AND_FORWARD(':auth'),
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        component: LogMeInAndrForward,
        pageTrackingName: 'LogMeInAndForward',
    },
    {
        path: ABHA_LINK(':hash'),
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        component: Abha,
        pageTrackingName: 'ABHALINKBULK',
    },
    {
        path: ABHA_LINK_COMPLETE(':abhaid'),
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        component: AbhaLinkComplete,
        pageTrackingName: 'ABHALINKBULK_COMPLETE',
    },
    {
        path: '*',
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        component: ErrorPage,
        pageTrackingName: 'Error_page_404',
    },
];

export default routes;
